<template>
  <Layout :top-bar-title="title" :sections="sections" :baseLayoutInfoUrl="'/base-layout-info/'">
    <TopicTable/>
  </Layout>
</template>

<script>
import Layout from '@/apps/core/components/Layout'
import TopicTable from '../components/tables/TopicTable'
import sections from './defaultNavigationDrawerSections'

export default {
  name: 'TopicList',
  components: { TopicTable, Layout },
  data () {
    return {
      sections: sections,
      title: this.$t('topics.sectionName')
    }
  }
}
</script>
